module.exports = __webpack_public_path__ + "static/media/Emily01_full.526735b7.gif";